/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByTagKind = (typeof GroupByTagKind)[keyof typeof GroupByTagKind];

export const GroupByTagKind = {
  tag: 'tag',
} as const;
